import { Avatar, Typography } from '@mui/material'
import { orange, red } from '@mui/material/colors'
import { MRT_ColumnDef } from 'material-react-table'
import React from 'react'

import { apiTipoUnidadMedida, ArticuloProps } from '../../../../interfaces/articulo.ts'
import { TipoArticuloOperacionProps } from '../../../../interfaces/tipoArticulo.ts'
import { getColor } from '../../../../utils/getColor.ts'
import { MrtTipoArticuloFilter } from '../../components/MrtTipoArticuloFilter.tsx'

/**
 * Lista de columnas para el listado de articulos
 */
export const articuloColumns: MRT_ColumnDef<ArticuloProps>[] = [
  {
    id: 'codigoArticulo',
    accessorKey: 'codigoArticulo',
    header: 'Código',
    size: 120,
    enableSorting: true,
  },
  {
    id: 'tipoArticulo',
    accessorKey: 'tipoArticulo',
    header: 'Tipo Articulo',
    size: 150,
    enableSorting: false,
    Cell: ({ cell }) => {
      return cell.getValue<TipoArticuloOperacionProps>()?.descripcion || ''
    },
    enableColumnFilter: true,
    filterVariant: 'select',
    // Sobrescribimos el componente de filtro por defecto
    Filter: ({ column }) => <MrtTipoArticuloFilter column={column} />,
  },
  {
    id: 'nombreArticulo',
    accessorKey: 'nombreArticulo',
    header: 'Nombre',
    Cell: ({ renderedCellValue, row }) => {
      return (
        <>
          {row.original.imagen ? (
            <Avatar src={row.original.imagen.variants.thumbnail} sx={{ width: 30, height: 30, mr: 2 }}>
              I
            </Avatar>
          ) : (
            <Avatar sx={{ width: 30, height: 30, mr: 2 }}>
              {row.original.nombreArticulo.charAt(0).toUpperCase()}
            </Avatar>
          )}
          {renderedCellValue}
        </>
      )
    },
    enableSorting: false,
  },
  {
    accessorKey: 'claseArticulo',
    header: 'Clase Articulo',
    size: 120,
    filterVariant: 'select',
    filterSelectOptions: ['PRODUCCION', 'SERVICIO', 'PRODUCTO'],
  },
  {
    accessorKey: 'gestionArticulo',
    header: 'Gestión Articulo',
    size: 120,
    enableSorting: false,
    filterVariant: 'select',
    filterSelectOptions: ['LOTE'],
  },
  {
    accessorKey: 'tipoUnidadMedida',
    header: 'Tipo Unidad',
    size: 120,
    enableSorting: false,
    filterVariant: 'select',
    filterSelectOptions: [
      { label: 'Simple', value: 'ArticuloUnidadMedida' },
      { label: 'Grupo U.M.', value: 'GrupoUnidadMedida' },
    ],
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === apiTipoUnidadMedida.articuloUnidadMedida ? 'Simple' : 'Grupo U.M.'
    },
  },
  {
    id: 'verificarStock',
    accessorKey: 'verificarStock',
    header: 'verificarStock',
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? 'SI' : 'NO'
    },
    muiTableBodyCellProps: ({ row }) => ({
      sx: (theme) => ({
        backgroundColor: row.original.verificarStock
          ? theme.palette.green.softBgColor
          : getColor(theme, orange[600]).bgColor,
        color: row.original.verificarStock ? theme.palette.green.softTextColor : red[800],
      }),
      align: 'center',
    }),
    size: 100,
    filterVariant: 'checkbox',
    muiFilterCheckboxProps: {
      title: 'Fil...',
    },
  },
  {
    accessorKey: 'articuloVenta',
    header: 'Venta',
    size: 65,
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? (
        <Typography variant={'subtitle2'} color={'success'}>
          SI
        </Typography>
      ) : (
        <Typography variant={'subtitle2'} color={'warning'}>
          NO
        </Typography>
      )
    },
    filterVariant: 'checkbox',
    muiFilterCheckboxProps: {
      title: 'Fil...',
    },
  },
  {
    accessorKey: 'articuloCompra',
    muiTableHeadCellProps: {
      title: 'Articulo compra (Insumo)',
    },
    size: 65,
    header: 'Compra',
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? (
        <Typography variant={'subtitle2'} color={'success'}>
          SI
        </Typography>
      ) : (
        <Typography variant={'subtitle2'} color={'warning'}>
          NO
        </Typography>
      )
    },
    filterVariant: 'checkbox',
    muiFilterCheckboxProps: {
      title: 'Fil...',
    },
  },
  {
    accessorKey: 'articuloProduccion',
    size: 65,
    header: 'Prod.',
    muiTableHeadCellProps: {
      title: 'Articulo producción',
    },
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? (
        <Typography variant={'subtitle2'} color={'success'}>
          SI
        </Typography>
      ) : (
        <Typography variant={'subtitle2'} color={'warning'}>
          NO
        </Typography>
      )
    },
    filterVariant: 'checkbox',
    muiFilterCheckboxProps: {
      title: 'Fil...',
    },
  },
  {
    accessorKey: 'activo',
    header: 'activo',
    size: 100,
    muiTableHeadCellProps: {
      align: 'center',
    },
    muiTableBodyCellProps: ({ row }) => ({
      sx: (theme) => ({
        bgcolor: row.original.activo ? getColor(theme, 'green').bgColor : getColor(theme, red[500]).bgColor,
        color: row.original.activo ? getColor(theme, 'green').textColor : getColor(theme, red[500]).textColor,
      }),
      align: 'center',
    }),
    Cell: ({ renderedCellValue }) => {
      return renderedCellValue === true ? <strong>SI</strong> : <strong>NO</strong>
    },
    filterVariant: 'checkbox',
    muiFilterCheckboxProps: {
      title: 'Fil...',
    },
  },
]
